import React from 'react';
import { Hourglass } from 'react-loader-spinner';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import phartrix_logo from '../assets/pharmtrix-logo.png';
import retail_logo from '../assets/rlogo.png';
import susImage from '../assets/subscriptionImage.png';
import { FaShoppingBag } from 'react-icons/fa';

const SubscribedPlans = () => {
    const navigate = useNavigate();
    const { data: subs, isLoading, error } = useSelector(state => state.subscribedPlans);

    const showSubscription = (data) => {
        const slug = data?.plan?.name 
            ? data.plan.name.toLowerCase().replace(/\s+/g, '-') 
            : `plan-${data?.id}`;
            
        navigate(`${slug}`, {
            state: {
               ...data
            }
        });
    };

    if (isLoading) {
        return (
            <div className="flex justify-center items-center w-full h-full bg-gradient-to-br from-opacity-40 to-opacity-60 backdrop-blur-sm absolute top-0 left-0">
                <Hourglass
                    visible={true}
                    height="40"
                    width="40"
                    ariaLabel="hourglass-loading"
                    wrapperStyle={{}}
                    wrapperClass=""
                    colors={['#306cce', '#72a1ed']}
                />
            </div>
        );
    }

    if (error) {
        return <div className='flex justify-center items-center w-full h-full'>Oops an error occurred</div>;
    }

    return (
        <div>
            <div className='flex flex-col sm:flex-row gap-3 sm:gap-0 sm:justify-end mb-5'>
                {subs?.length > 0 && (
                    <>
                        <p className='text-center text-gray-600 sm:hidden'>Click on the button below to view more subscriptions</p>
                        <Link to='/plans'>
                            <button className='flex items-center justify-self-center justify-center gap-1 text-sm text-white border bg-[#2169E8] py-2 px-8 rounded-xl shadow-md hover:shadow-none transition-all duration-300 delay-1000'>
                                <span>Subscribe</span>
                            </button> 
                        </Link>
                    </>
                )}
            </div>

            <div>
                {!subs || subs.length === 0 ? (
                    <div className='h-full flex flex-col gap-4 justify-center items-center'>
                        <div className='w-full h-full flex justify-center'>
                            <img 
                                src={susImage} 
                                alt="No subscriptions" 
                                className='w-[20rem] h-[14rem] md:w-[25rem] md:h-[18rem]'
                            />
                        </div>
                        <p className='text-center text-sm text-gray-600'>
                            You have no subscriptions! Click on <br/>the button below to get started.
                        </p>
                        <Link to='/plans'>
                            <button className='flex items-center justify-center gap-1 text-sm text-white border bg-blue-800 h-10 px-8 rounded-xl shadow-md animate-bounce hover:animate-none transition-all duration-300 delay-1000'>
                                <span>Subscribe</span>
                                <FaShoppingBag size={15} />
                            </button>
                        </Link>
                    </div>
                ) : (
                    subs.map((item) => (
                        <div key={item.id} className='mb-4'>
                            <div className='bg-[#EFFCFF] border border-gray-200 shadow flex flex-col md:flex-row justify-between p-1 rounded-lg gap-1'>
                                <div className='flex m-0 gap-3 items-center'>
                                    <div className='flex items-center justify-center'>
                                        {item?.plan?.app === 'pharmtrix-wholesale' && (
                                            <img 
                                                src={phartrix_logo} 
                                                alt="Pharmtrix Wholesale" 
                                                className='h-12 w-12 sm:h-15 sm:w-15 rounded-sm shadow-xl object-cover object-center'
                                            />
                                        )}
                                        {item?.plan?.app === 'pharmtrix-retail' && (
                                            <img 
                                                src={retail_logo} 
                                                alt="Pharmtrix Retail" 
                                                className='-my-2 h-12 w-12 sm:h-15 sm:w-15 rounded-sm shadow-xl object-cover object-center'
                                            />
                                        )}
                                    </div>
                                    <div className='flex flex-col justify-center'>
                                        <p className='text-base sm:text-[1.2rem] font-semibold'>{item?.plan?.name}</p>
                                        <p className='text-[0.8rem] sm:text-sm text-gray-600'>
                                            Elite Subscription for {item?.plan?.app === 'pharmtrix-wholesale' ? 'Pharmtrix Wholesale' : 'Pharmtrix Retail'}
                                        </p>
                                    </div>
                                </div>
                                <div className='flex items-center justify-end'>
                                    <button
                                        onClick={() => showSubscription(item)}
                                        className='text-white bg-[#4095D6] font-medium rounded-lg text-xs sm:text-sm px-8 h-8 focus:outline-none shadow-xl hover:shadow-none transition-all duration-300 delay-1000'
                                    >
                                        Manage
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
};

export default SubscribedPlans;
